import { SET_COLLECTIONS, CLEAR_COLLECTIONS } from '@actions/collection'

const defaultState = {
  list: null,
}

const collectionsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_COLLECTIONS: {
      const { data } = action

      return {
        ...state,
        list: data,
      }
    }
    case CLEAR_COLLECTIONS: {
      return defaultState
    }

    default:
      return state
  }
}

export default collectionsReducer
